<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Student Uniform Indents">
      <v-btn
        class="add-audit-offline"
        v-on:click="
          () => {
            $router.push({ name: 'uniformIndent' })
          }
        "
        elevation="1"
        :class="{ 'mt-2': $vuetify.breakpoint.xs }"
        color="accent"
      >
        <v-icon left>mdi-plus</v-icon>
        Generate New Indent
      </v-btn>
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <!--Filter Section Start -->
        <v-row>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">
              Class
            </label>
            <multiselect
              class="overflowmultiselect2"
              label="name"
              track-by="id"
              @input="getStudentDetails()"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :multiple="true"
              :options="classes"
              v-model="selectedClassIDs"
            >
            </multiselect>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <span class="font-weight-medium body-2">Action</span>
            <div class="inside">
              <v-btn elevation="1" color="success" @click="getStudentDetails()"> <v-icon left>mdi-magnify</v-icon>Search </v-btn>
            </div>
          </v-col>
        </v-row>
        <!--Filter section end -->
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table :items-per-page="10" item-key="id" :headers="headers" :items="studentList" disable-pagination hide-default-footer>
        <!--No Data template start -->
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
        <!--No Data template end -->
      </v-data-table>
      <!--Pagination start-->
      <v-row>
        <v-col cols="4" sm="3">
          <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
        </v-col>
        <v-col cols="12" sm="9">
          <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages" @input="handlePageChange"> </v-pagination>
        </v-col>
      </v-row>
      <!--Pagination end-->
    </material-card>
    <!-- Loader Start -->
    <loading-icon :value="isLoading" />
    <!-- Loader End -->
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'
import constants from '@/utils/constants'
import moment from 'moment'
// import moment from 'moment'
export default {
  name: 'indentListing',
  components: { MaterialCard, Multiselect },
  created () {
    // this.getClassList()
    this.getSingleClassList()
    this.getStudentDetails()
  },
  mounted () {},
  data: function () {
    return {
      headers: [
        { text: 'Student Name', sortable: true, value: 'enquiry.studentEnrollment.studentName' },
        //  { text: 'Status', sortable: false, value: 'studentEnrollment.gender' },
        { text: 'Class', sortable: false, value: 'studentClass.name' },
        { text: 'Enrollment Code', sortable: false, value: 'enquiry.enrollmentCode' },
        { text: 'Uniform Type', sortable: false, value: 'productApparel.productApparelType.type' },
        { text: 'Product', sortable: false, value: 'productApparel.productName' },
        { text: 'Size', sortable: false, value: 'size' },
        { text: 'Qty', sortable: false, value: 'quantity' }
        // { text: 'Created Date', sortable: false, value: 'updatedAt' }
      ],
      classSectionArray: [],
      classes: [],
      selectedClassIDs: [],
      selectedClassSectionArray: [],
      studentList: [],
      selectedStudentList: [],
      filter: {
        classId: '',
        sectionId: '',
        franchiseeId: '',
        academicYearID: ''
      },
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      if (val) {
        this.filter.franchiseeId = val.id
        this.getClassList()
        this.getStudentDetails()
      }
    },
    academicYear: function (val) {
      if (val) {
        this.filter.academicYearId = val.id
        this.getClassList()
        this.getStudentDetails()
      }
    }
  },
  methods: {
    getStudentDetails: async function () {
      try {
        let payload = {}
        payload.franchiseeID = this.franchisee.id
        payload.academicYearID = this.academicYear.id
        // let classIds = this.selectedClassSectionArray.map(item => {
        //   return item.classID
        // })
        let classIds = this.selectedClassIDs.map(item => {
          return item.id
        })
        if (classIds.length > 0) {
          payload.classID = classIds
        }
        // let sectionIds = this.selectedClassSectionArray.map(item => {
        //   return item.id.sectionID
        // })
        // if (sectionIds.length > 0) {
        //   payload.sectionID = sectionIds
        // }
        let { data } = await http.post(`${constants.API_URL}/api/product/student-uniform/details`,
          Object.assign({
            page: this.page - 1,
            size: this.pageSize
          }, payload))
        this.studentList = data.rows.map(student => {
          student.updatedAt = moment(student.updatedAt).format('ll')
          // Searching in the selected student list
          let isSelectedIndex = this.selectedStudentList.map(item => item.id).indexOf(student.id)
          // Marking the checkbox as true if the student already selected
          student.isSelected = isSelectedIndex > -1
          return student
        })
        this.totalPages = data.totalPages
        console.log(this.studentList)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)
        // this.errMsg(errorMessage)
      }
    },
    getSingleClassList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/student/class-section`)
        const data = response.data
        this.classes = data
        // Selecting the first class ID

        // this.selectedClassID = this.classes[0].id

        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        this.classSectionArray = []

        let { data } = await http.get(`${constants.API_URL}/api/student/get-all-classby-franchisee`, {
          params: {
            franchiseeID: this.franchisee?.id || '',
            academicYearID: this.academicYear?.id || ''
          }
        })

        if (data) {
          var z = []
          _.map(data, a => {
            _.map(a.studentSections, b => {
              let franchiseeName = b.studentAdmissions[0].franchisee.companyName
              let franchiseeId = b.studentAdmissions[0].franchisee.id
              b.value = `${franchiseeName}-${a.name} - ${b.name}`
              b.id = { franchiseeID: franchiseeId, sectionID: b.id }
              z.push(b)
            })
          })
        }

        this.classSectionArray = z
        console.log(this.classSectionArray, 'Data')
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        // this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    selectStudentHandler: function (student) {
      console.log(student.isSelected)
      // Searching in the selected student list
      let isSelectedIndex = this.selectedStudentList.map(item => item.id).indexOf(student.id)
      if (isSelectedIndex > -1) {
        // This student is already selected
        if (!student.isSelected) {
          // Deselecting the student as checkbox is unchecked
          this.selectedStudentList.splice(isSelectedIndex, 1)
        }
      } else {
        this.selectedStudentList.push(student)
      }
      console.log('Selected List:', this.selectedStudentList.length)
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getStudentDetails()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getStudentDetails()
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
